import { useState } from 'react';
import moment from "moment/moment";
import { standardDateFormat } from "../../utils/momentHelpers";
import CopyText from "../layout/CopyText";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import { Link45deg } from "react-bootstrap-icons";
import Loading from "../Loading";
import useApiCall from "../hooks/useApiCall";
import { backendEndpoints } from "../../libs/backendEndpoints";

interface GroupJoinData {
    url?: string;
    expires_at?: string;
}

/**
 * Generates and displays a secure shareable group join link with an expiration date.
 */
export default function GenerateGroupJoinLink({ groupId }: {
    /** The ID of the group for which to generate a join link. */
    groupId: number;
}) {
    const [{ url: groupJoinUrl, expires_at: expiresAt }, setGroupJoinData] = useState<GroupJoinData>({});
    const { onSubmit, isSubmitting, error: submitError } = useApiCall({
        url: backendEndpoints.createJoinUrl(groupId),
    });

    return (
        <>
            {groupJoinUrl ? (
                <>
                    <p>Below link is valid until {moment(expiresAt).format(standardDateFormat)}.</p>
                    <CopyText text={groupJoinUrl} />
                </>
            ) : (
                <>
                    {submitError && <Alert>{submitError}</Alert>}
                    <Button
                        size="sm"
                        disabled={isSubmitting}
                        onClick={() => {
                            onSubmit().then((joinData) => {
                                setGroupJoinData(joinData);
                            })
                        }}
                    >
                        <Link45deg />
                        &nbsp;Generate secure group link
                        {isSubmitting && <Loading size="sm" />}
                    </Button>
                </>
            )}
        </>
    );
}
